import { render, staticRenderFns } from "./list.vue?vue&type=template&id=94d01f90&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=94d01f90&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d01f90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94d01f90')) {
      api.createRecord('94d01f90', component.options)
    } else {
      api.reload('94d01f90', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=94d01f90&scoped=true", function () {
      api.rerender('94d01f90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/promo/list.vue"
export default component.exports